module.exports = __webpack_public_path__ + "img/Thailand-5-hover.cfc361f5.jpg";